namespace GeniuzPOS.PosShift {
    export interface ReportRecvbyCashierbyDateRow {
        Id?: string;
        CreateDate?: string;
        CashierId?: string;
        CashierName?: string;
        PaymentType?: number;
        PaymentName?: string;
        RefType?: string;
        CurrencyCode?: string;
        ReceiptAmt?: number;
        PointBurn?: number;
        CountTime?: number;
    }

    export namespace ReportRecvbyCashierbyDateRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CashierId';
        export const localTextPrefix = 'PosShift.ReportRecvbyCashierbyDate';
        export const lookupKey = 'PosShift.ReportRecvbyCashierbyDate';

        export function getLookup(): Q.Lookup<ReportRecvbyCashierbyDateRow> {
            return Q.getLookup<ReportRecvbyCashierbyDateRow>('PosShift.ReportRecvbyCashierbyDate');
        }
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:สรุปการรับเงินแคชเชียร์:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:สรุปการรับเงินแคชเชียร์:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:สรุปการรับเงินแคชเชียร์:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:สรุปการรับเงินแคชเชียร์:View';

        export declare const enum Fields {
            Id = "Id",
            CreateDate = "CreateDate",
            CashierId = "CashierId",
            CashierName = "CashierName",
            PaymentType = "PaymentType",
            PaymentName = "PaymentName",
            RefType = "RefType",
            CurrencyCode = "CurrencyCode",
            ReceiptAmt = "ReceiptAmt",
            PointBurn = "PointBurn",
            CountTime = "CountTime"
        }
    }
}
